// JSON fetch for the /face routes: resolves {ok, status, body, message} and never throws
// (the same contract as utils/beacons.js beaconFetch).
//
// Deliberately free of config.js: utils/pinPrompt.js loads the face code, and pinPrompt is
// imported by ~40 components whose tests don't mock axios (config.js imports it). The API key
// still rides along: config.js wraps window.fetch at app start and adds X-API-Key to every
// request to the API base URL, and this calls the global fetch at request time.

import { detailToString } from '../utils/apiError';

export function apiBase() {
  return process.env.REACT_APP_API_BASE_URL || '';
}

export async function faceFetch(path, opts = {}) {
  try {
    const res = await fetch(`${apiBase()}${path}`, {
      ...opts,
      headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
    });
    let body = null;
    try { body = await res.json(); } catch (_) { body = null; }
    const detail = body && typeof body === 'object' ? body.detail : null;
    const message = res.ok ? null
      : (detail && typeof detail === 'object' && detail.message) || detailToString(detail) || `HTTP ${res.status}`;
    return { ok: res.ok, status: res.status, body, message };
  } catch (e) {
    return { ok: false, status: 0, body: null, message: 'Could not reach JobQ.' };
  }
}
